import { getTagCustomOrderByGrouping } from '@griply/utils';
import { useMemo } from 'react';
import { TaskGroupBy } from 'shared/types/sorting-mode';
import { Tag } from 'shared/types/tag';
import { noGroupingId } from 'shared/views/task-filter-list';

export const useTagCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  tag?: Tag,
) =>
  useMemo(
    () =>
      getTagCustomOrderByGrouping({
        groupBy,
        tag,
        noGroupingKey: noGroupingId,
      }),
    [groupBy, tag],
  );
